<template>
  <div>
    <v-container fluid>
      <v-row class="ma-0">
        <v-col cols="12">
          <v-data-table
            class="elevation-1"
            :headers="table.headers"
            :items="table.items"
            :items-per-page="5"
            :single-select="true"
            no-data-text="Belum ada data !"
            hide-default-footer
          >
            <template v-slot:item.jenisPengadaan="{item}">
                {{ getJenisPengadaan(item.jenisPengadaan) }}
            </template>

            <template v-slot:item.metodePemilihan="{item}">
                {{ getMetodePemilihan(item.metodePemilihan) }}
            </template>

            <template v-slot:item.totalPagu="{item}">
              {{ getNumberSep(item.totalPagu) }}
            </template>

            <template v-slot:item.actions="{item}">
              <v-btn color="blue" small icon @click="openForm(item, true)"> <v-icon small class="mr-2">mdi-file-find</v-icon> </v-btn>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
      <v-row class="ma-0">
          <v-col> <v-btn class="light-blue darken-4 text-capitalize" dark to="/lelang">Selengkapnya >></v-btn> </v-col>
      </v-row>

      <v-row>
        <!-- INFORMASI -->
        <v-col>
          <v-list class="transparent">
            <v-list-item> 
              <v-list-item-title class="text-h5 font-weight-bold">Informasi</v-list-item-title>
            </v-list-item>
            <v-list-item two-line v-for="(informasi, i) in listInformasi" :key="i">
              <v-list-item-content class="blue--text">
                <v-list-item-title>{{ getDateFormattedDatefns(informasi.createdAt) }}</v-list-item-title>
                <v-list-item-title>{{ informasi.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-btn class="light-blue darken-4 text-capitalize" dark to="/informasi">Selengkapnya >></v-btn>
            </v-list-item>
          </v-list>
        </v-col>

        <!-- BERITA -->
        <v-col>
          <v-list class="transparent">
            <v-list-item> 
              <v-list-item-title class="text-h5 font-weight-bold">Berita dan Pemberitahuan</v-list-item-title>
            </v-list-item>
            <v-list-item two-line v-for="(berita, i) in listBerita" :key="i">
              <v-list-item-content class="blue--text">
                <v-list-item-title>{{ getDateFormattedDatefns(berita.createdAt) }}</v-list-item-title>
                <v-list-item-title>{{ berita.title }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item>
              <v-btn class="light-blue darken-4 text-capitalize" dark to="/berita">Selengkapnya >></v-btn>
            </v-list-item>
          </v-list>
        </v-col>
      </v-row>
    </v-container>


    <v-dialog v-model="form.isShowing" persistent max-width="80%">
      <v-container>
        <v-card>   
          <v-card-text>
            <v-tabs
              v-model="tab"
              fixed-tabs
              background-color="indigo"
              dark
            >
              <v-tab>
                Informasi
              </v-tab>             
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item>
                <PreviewLelangVendor></PreviewLelangVendor>
              </v-tab-item >              
            </v-tabs-items>
          </v-card-text>
            <v-card-actions>
                <v-btn color="cyan" dark @click="closeForm">Tutup</v-btn>
            </v-card-actions>        
        </v-card>
        </v-container>
    </v-dialog>

  </div>
</template>


<script>

const apiUrl = process.env.VUE_APP_ROOT_API
const axios = require('axios').default;

import { itemsMetodePemilihan, itemsJenisPengadaan, getJadwalLelang } from './../lib/viewTenderLib'
import { getValueItem, tahunAnggaran, } from './../lib/viewLib'
import PreviewLelangVendor from './../components/lelang/PreviewLelangVendor'
import { format } from 'date-fns'


export default {
  components: {
    PreviewLelangVendor,
  },
  data: function() {
    return {
      appBar: true,
      tab: null,
      tahunAnggaranSel: 2021,
      itemsTahunAnggaran: tahunAnggaran,
      listJadwal: [],

      // Table
      table:
      {
        headers: 
        [
          { text: "Kode", value: "kode", class:"light-blue lighten-2 subtitle-1 font-weight-bold" },
          { text: "Nama Paket", value: "nama", class:"light-blue lighten-2 subtitle-1 font-weight-bold" },
          { text: "Pengadaan", value: "jenisPengadaan", class:"light-blue lighten-2 subtitle-1 font-weight-bold" },
          { text: "Pemilihan", value: "metodePemilihan", class:"light-blue lighten-2 subtitle-1 font-weight-bold" },
          { text: "HPS", value: "totalPagu", align: 'end', class:"light-blue lighten-2 subtitle-1 font-weight-bold"},
          { text: "Actions", value: "actions", sortable: false, class:"light-blue lighten-2 subtitle-1 font-weight-bold" }
        ],
        items: []
      },

      form:
      {
        paket:
        {
          kode: "",
          kegiatanId: 0,
          ppk: "",
          id: null,
          nama: "",              
          tahunAnggaran: 0,
          isPDN: false,
          isUsahaKecil: false,
          satuanKerja: "",
          volumePekerjaan: 1,
          listLokasiKerja: [],
          listPendanaan: [],
          
          totalPagu: 0,
          totalPaguLama: 0,
          kbli: "",
          bobotTeknis: 0,
          bobotHarga: 0,
          deskripsi: '',

          jenisPengadaan: "",
          metodePemilihan: "",
          metodeEvaluasi: "",
          kualifikasi: "",
          jenisKontrak: "",

          pelaksanaanKontrakAwal: null, 
          pelaksanaanKontrakAkhir: null, 
          pelaksanaanPemilihanPenyediaAwal: null, 
          pelaksanaanPemilihanPenyediaAkhir: null,

          fileLain: null,
          fileLampiran: null,
          fileKAK: null,
        },
        programId: 0,
        isShowing: false,
        isEditing: false,
        isView: false,
        isDeleting: false,
        isValid: false
      },

      listJenisPengadaan: [],
      allListMetodePemilihan: itemsMetodePemilihan,

      // Berita dan Informasi 
      listInformasi: [],
      listBerita: [],

    }
  },
  created: async function() { 
    this.tahunAnggaranSel = this.$store.getters.tahunAnggaran
    await this.getData()
    this.listJenisPengadaan = itemsJenisPengadaan    
    // await this.getListVendor()

    axios.get(`${apiUrl}/api/berita-informasi/latest/I`)
    .then( (response) => {
      this.listInformasi = response.data;
      //console.log("INFORMASI: ", this.listInformasi);

    }).catch( (error) => {
      console.error(error);
    });

    axios.get(`${apiUrl}/api/berita-informasi/latest/B`)
    .then( (response) => {
      this.listBerita = response.data;
      //console.log("BERITA: ", this.listBerita);

    }).catch( (error) => {
      console.error(error);
    });

  },
  methods: {
    tahunAnggaranSelChange() {
      this.getData()
    },
    getNumberSep: function(data) {
      return parseInt(data, 10).toLocaleString('de-DE')
    },
    getJenisPengadaan(val) {
        return val ? getValueItem(this.listJenisPengadaan, val) : ''
    },
    getMetodePemilihan: function(val) {
      return val ? getValueItem(this.allListMetodePemilihan, val) : ''
    },
    getData() {
      axios.get(`${apiUrl}/api/rup/paket/info/tahun/${this.tahunAnggaranSel}`)
      .then( (response) => { 
        this.table.items = response.data.filter(el => el.metodePemilihan !== 'TLA');
        // console.log("LIST PAKET: ", response.data); 
      })
      .catch( (error) => { console.error(error); });
    },
    getDateFormattedDatefns: function(date) {
      return date ? format(Date.parse(date), "dd MMM yyyy") : ''
    },
    async openForm(paket, view) {
      this.tab = 0
      if (paket)          
      {
        this.form.paket = Object.assign({}, paket);

        this.listJadwal = await getJadwalLelang(paket.id)

        // assign store
        this.$store.dispatch('lelang/assignPaket', paket)
        this.$store.dispatch('lelang/assignJadwal', this.listJadwal)
        
        // axios.get(apiUrl+`/api/rup/paket/jadwal/${paket.id}`)
        // .then( (response) => {
        //     // console.log("List jadwal: ", response.data);
        //     this.listJadwal = response.data;
        // });

        this.form.isEditing = true;
        this.form.isShowing = true; 
        this.form.isView = view;
        console.log(this.form.isView)
          
      }
      else
      {
        this.resetForm();
        this.form.isShowing = true;
      }          
    },
    closeForm() {
        this.form.isShowing = false;
        this.form.isEditing = false;
        this.form.isDeleting = false;
        this.form.isView = false;
        this.tab = 0
    },
  }
}
</script>

<style scoped>
.container{
  max-width: 100vw;
  padding:0px;
}
.bg {
  background: url('./../assets/sarana01.jpg');
  background-size: cover;
}

</style>
